import {InputLabel, MenuItem, Select} from "@mui/material";
import Stack from "@mui/material/Stack";
import {useEffect, useState} from "react";
import FormControl from "@mui/material/FormControl";
import useCallDataApi from "../../hooks/data";
import useDataModel from "../../hooks/dataModel";


const DailyData = ({reference}) => {
    const [courier, setCourier] = useState("")

    const {fetchModel, models: couriers, setModels: setCouriers} = useDataModel(useCallDataApi("users"))

    useEffect(() => {
        fetchModel('get_couriers', models => setCouriers(models))
    }, [])

    return <form ref={reference}>
        <Stack>
            <FormControl sx={{m: 1, minWidth: 120}}>
                <InputLabel id="courier-select">Futár</InputLabel>
                <Select
                    labelId="courier-select"
                    label="Futár"
                    id="courier"
                    name="courier"
                    value={courier}
                    onChange={e => setCourier(e.target.value)}
                >
                    {couriers.map(courier => (
                        <MenuItem key={courier.id} value={courier.id}>{courier.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Stack>
    </form>;
}

export default DailyData